<div class="dialog-form-dashboard">
  <header class="dialog-form-dashboard__header">
    <div class="dialog-form-dashboard__heading">
      <ui-atom-text
        type="title"
        [text]="'forms.dashboard.dialogTitle' | translate"
      ></ui-atom-text>
      <ui-atom-text
        type="medium"
        [text]="data.formName"
        class="dialog-form-dashboard__form-name"
      ></ui-atom-text>
      @if (data.scopeLabel) {
        <ui-atom-text
          type="small"
          [text]="data.scopeLabel"
          class="dialog-form-dashboard__scope"
        ></ui-atom-text>
      }
    </div>
    <button
      type="button"
      class="dialog-form-dashboard__expand"
      [attr.aria-label]="isExpanded ? 'Collapse dialog' : 'Expand dialog'"
      (click)="toggleExpanded()"
    >
      <mat-icon>{{ isExpanded ? 'close_fullscreen' : 'open_in_full' }}</mat-icon>
    </button>
  </header>

  <main class="dialog-form-dashboard__body">
    @if (isEmpty) {
      <div class="dialog-form-dashboard__empty">
        <mat-icon>bar_chart</mat-icon>
        <ui-atom-text
          type="medium"
          [text]="'forms.dashboard.empty' | translate"
        ></ui-atom-text>
      </div>
    }
    <div #vizContainer class="dialog-form-dashboard__viz" [class.dialog-form-dashboard__viz--hidden]="isEmpty"></div>
  </main>

  <footer class="dialog-form-dashboard__footer">
    <ui-atom-button
      type="button"
      rules="main"
      styling="outlined"
      [withShadow]="false"
      [text]="'buttons.close' | translate"
      (buttonClick)="onClose()"
    ></ui-atom-button>
  </footer>
</div>
